import React from 'react';
import './ContentPlugins.css';

export default function PluginPickerModal({ open, plugins, onClose, onSelectPlugin }) {
  if (!open) return null;

  return (
    <div className="contentPluginOverlay" onClick={onClose} role="presentation">
      <div className="contentPluginModal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <h2 className="contentPluginTitle">Choose a Plugin</h2>
        <div className="contentPluginChoices">
          {(plugins || []).map((p) => (
            <button
              key={p.id}
              type="button"
              className="contentPluginChoice"
              onClick={() => onSelectPlugin(p.id)}
            >
              <span className="contentPluginChoiceIcon">{
                p.id === 'weather' ? '🌤️' : p.id === 'sports' ? '🏆' : p.id === 'social' ? '📱' : p.id === 'trivia' ? '🎯' : '🧩'
              }</span>
              <span className="contentPluginChoiceLabel">{p.name}</span>
              <span className="contentPluginChoiceDesc">{p.description}</span>
            </button>
          ))}
        </div>
        <button type="button" className="contentPluginCancel" onClick={onClose}>Back</button>
      </div>
    </div>
  );
}
